var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav mr-auto navbar-navigation"},_vm._l((_vm.routes),function(value,index){return _c('li',{key:index},[_c(value.label,{tag:"router-link",class:[
        _vm.analysis === value.item.analysis
          ? 'link-selected nav-item'
          : 'nav-item',
        value.item.class
      ],style:(value.item.style),attrs:{"to":{ name: value.item.name }}},[_vm._v("\n      "+_vm._s(value.item.show_name)+"\n    ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }